import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    overflow: "scroll !important",
    height: "100%",
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  content: {
    padding: `${theme.spacing.space8}px ${theme.spacing.space16}px`,
    marginTop: 70,
    gap: theme.spacing.space24,
    display: "flex",
    flexDirection: "column",
  },
  levelContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `0 ${theme.spacing.space16}px`,
  },
  gemNeeded: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 2,
  },
  progressContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    paddingTop: theme.spacing.space8,
  },
  allLevelsContainer: {
    padding: `${theme.spacing.space20}px ${theme.spacing.space16}px`,
    background: theme.colors.Background3,
    borderRadius: theme.radius.large,
    display: "grid",
    gap: theme.spacing.space24,
  },
  gemCollected: {
    padding: `${theme.spacing.space12}px ${theme.spacing.space16}px`,
    background: theme.colors.Background4,
    borderRadius: theme.radius.medium,
    display: "flex",
    gap: theme.spacing.space12,
    alignItems: "center",
  },
  gemCollectedContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  allLevelsContent: {
    display: "grid",
    gap: theme.spacing.space16,
  },
  levelItem: {
    display: "flex",
    gap: theme.spacing.space8,
    alignItems: "center",
  },
  gem: {
    display: "flex",
    alignItems: "center",
  },
  gemIconTo: {
    padding: `0 ${4}px`,
  },
  earnGemTips: {
    padding: theme.spacing.space16,
    background: theme.colors.Background3,
    borderRadius: theme.radius.large,
    gap: theme.spacing.space16,
    display: "grid",
  },
  tipItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  levelName: {
    textTransform: "capitalize",
  },
}));
